import React from 'react';
import { useState } from 'react';
import Popup from './popup';
import './header.css';

function Header(props) {
    const { handleDeleteAll } = props;

    const [isPopupHelpOpen, setPopupHelpOpen] = useState(false);
    const [isPopupOptionOpen, setPopupOptionOpen] = useState(false);

    const openPopupHelp = () => {
        setPopupHelpOpen(true);
    };
    
    const closePopupHelp = () => {
        setPopupHelpOpen(false);
    };

    const openPopupOption = () => {
        setPopupOptionOpen(true);
    };
    
    const closePopupOption = () => {
        setPopupOptionOpen(false);
    };

    return (
        <div>
            <header className="header">
                <h1>ラクコピ</h1>
                <button className="header_button header_button_option" onClick={openPopupOption}></button>
                <button className="header_button header_button_help" onClick={openPopupHelp}></button>
            </header>

            <Popup isOpen={isPopupHelpOpen} onClose={closePopupHelp}>
                <div className="popup_content_title">このアプリについて</div>
                <div className="popup_content_text">
                    <ul>
                        <li>スマートフォン上でのコピー＆ペースト操作をラクにする、インストール不要のWebアプリです。</li>
                        <li>複数の単語をクリップボードに登録してワンタッチでコピーできます。登録内容はブラウザに保存されるため、ブラウザを閉じても繰り返し使用できます。</li>
                        <li>URLやメールアドレスなど、よく使う単語や定型文などのコピペに活用ください。</li>
                        <li>ブラウザに保存した単語データは、左上の歯車アイコンから一括削除できます。</li>
                    </ul>
                </div>
            </Popup>

            <Popup isOpen={isPopupOptionOpen} onClose={closePopupOption}>
                <div className="popup_content_title">オプション</div>
                <div className="popup_content_text">
                    <button onClick={handleDeleteAll} class="btn_option">すべてのクリップを削除する</button>
                </div>
            </Popup>
        </div>
    );
}

export default Header;
